import { PdButton } from "./pd-button/PdButton.js";
//#region src/pd-button/pd-button.ts
var tag = "pd-button";
if (!customElements.get(tag)) customElements.define(tag, PdButton);
//#endregion
export { PdButton };
